export default __webpack_public_path__ + "static/media/aquasil-ultra-flexitime.581ead72.png";